import { Navigate, Outlet } from 'react-router-dom';
import type { UserRole } from '@proref/types';
import { useAuth } from '../contexts/auth-context';
import { Spinner } from './shared/Spinner';

// Full-screen loader shown while the initial session check resolves — avoids flashing /login
// for an already-authenticated user on a hard refresh.
function FullScreenLoader() {
  return (
    <div className="grid min-h-screen place-items-center bg-bg text-muted">
      <Spinner className="w-6 h-6" />
    </div>
  );
}

// Gate for any authenticated route. Renders the nested routes once a user is present.
export function RequireAuth() {
  const { user, isLoading } = useAuth();
  if (isLoading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

// Gate for role-restricted routes (e.g. the admin invite module). Assumes it sits inside
// RequireAuth, so a user is guaranteed present; a wrong role bounces to the app home.
export function RequireRole({ roles }: { roles: UserRole[] }) {
  const { role } = useAuth();
  if (!role || !roles.includes(role)) return <Navigate to="/" replace />;
  return <Outlet />;
}
